import React from 'react';
import './App.css';
import Home from './Accueil/Home';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {isLogged} from './store/auth/getter';
import propTypes from 'prop-types';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import QuestionnaireClient from './QuestionnaireClient'
import {Login} from './views';

function App() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/admin" component={Home} exact/>
                <Route path="/:token" component={QuestionnaireClient}/>
            </Switch>
        </BrowserRouter>
    );
}

export default App;
